import FilterPopOver from "components/FilterPopOver";
import { CloseIcon, FilterIcon } from "components/icons";
import SelectMultipleTag from "components/SelectMultipleTag";

import useBUUnassignedMemberFilter from "./useBUUnassignedMemberFilter";
import { useTranslationContext } from "context/TranslationContext";

import { TGetBUUnassignedMemberFilter } from "../../Model/types";
import { MEMBER_TYPE_TAG_OPTIONS } from "../../Model/constants";

interface FilterProps {
  filter?: Partial<TGetBUUnassignedMemberFilter>;
  onFilter?: (filter: Partial<TGetBUUnassignedMemberFilter>) => void;
}

const Filter = ({ filter, onFilter }: FilterProps) => {
  const { t } = useTranslationContext();

  const {
    memberTypeTags,
    setMemberTypeTags,
    hasFilterValue,
    openFilter,
    onCloseAndResetFilter,
    onResetFilter,
    onSubmitFilter,
    onOpenFilter,
    onCloseFilter,
  } = useBUUnassignedMemberFilter({ filter, onFilter });

  return (
    <div className="relative">
      {!hasFilterValue ? (
        <button
          onClick={onOpenFilter}
          className="flex justify-center items-center rounded-md border border-gray-200 h-[2.64rem] w-[2.64rem] hover:shadow-[0px_0px_1px_1px_rgb(0,122,245,0.4)] hover:ring-primary-500"
        >
          <FilterIcon width={18} height={18} />
        </button>
      ) : (
        <div className="flex gap-2 items-center justify-between border border-primary-150 bg-primary-50 text-primary-500 px-3 h-[2.64rem] rounded-lg text-base">
          <button
            className="flex items-center justify-start gap-2"
            onClick={onOpenFilter}
          >
            <FilterIcon width={16} height={16} />
            {t("filter")}
          </button>
          <button
            className="border-l border-primary-150 flex items-center justify-center pl-1"
            onClick={onCloseAndResetFilter}
          >
            <CloseIcon width={15} height={15} />
          </button>
        </div>
      )}

      {openFilter && (
        <FilterPopOver
          onClose={onCloseFilter}
          title={t("filter")}
          onSubmitFilter={onSubmitFilter}
          onResetFilter={onResetFilter}
          submitButtonActive={true}
          hasValue={!!memberTypeTags.length}
        >
          <SelectMultipleTag
            values={memberTypeTags}
            setValues={setMemberTypeTags}
            label={t("account_type")}
            options={MEMBER_TYPE_TAG_OPTIONS}
            placeHolder={t("choose_account_type")}
          />
        </FilterPopOver>
      )}
    </div>
  );
};

export default Filter;
